import { Observable } from 'rxjs';
import { ActionOptionsArgs } from '../../../core/store/actions/base-actions';
import { AccountObjectStoreFacade } from '../account-object/account-object.store-facade';
import { Category } from '../category/category.model';
import { CategoryStoreFacade } from '../category/category.store-facade';
import { Qry } from '../query-facade';
import { Task } from '../task/task.model';
import * as actions from './task-type.actions';
import { TaskType } from './task-type.model';

export class TaskTypeStoreFacade extends CategoryStoreFacade<TaskType> {

    getAll(): Observable<Array<TaskType>> {
        return this.select(Qry.getInstance().taskType.byActiveAccount);
    }

    getForAllAccounts(): Observable<Array<TaskType>> {
        return this.select(Qry.getInstance().taskType.items);
    }

    getFiltered(): Observable<Array<TaskType>> {
        return this.select(Qry.getInstance().taskType.filtered);
    }

    create(taskType: TaskType): void {
        this.dispatch(new actions.SubmitAction(taskType));

        this.appFacade.objects.membership.store.getActive().take(1).subscribe(membership => {
            this.appFacade.objects.membership.store.attachTaskType(membership, taskType, {restful: false, persistable: true});
        });

        this.appFacade.objects.membership.store.enqueueRefresh();
    }

    update(taskType: TaskType): void {
        this.dispatch(new actions.SubmitAction(taskType));
    }

    insert(taskType: TaskType): void {
        this.dispatch(new actions.SubmitAction(taskType, {persistable: true, restful: false}));
    }

    remove(taskType: TaskType, options?: ActionOptionsArgs): void {
        this.appFacade.objects.task.store.removeByTaskType(taskType, options);

        this.appFacade.objects.membership.store.getActive().take(1).subscribe(membership => {
            this.appFacade.objects.membership.store.detachTaskType(membership, taskType, {restful: false, persistable: true});
        });

        this.dispatch(new actions.RemoveAction(taskType, options));

        this.appFacade.objects.membership.store.enqueueRefresh();
    }

    setFilters(filters): void {
        this.dispatch(new actions.SetFilterAction(filters));
    }

    protected checkHasDependency<R extends Task>(facade: AccountObjectStoreFacade<Task>, category: Category, dependantEntityName: string): Observable<boolean> {
        return facade
            .getAll()
            .map(items => !items.find(item => item.taskType === category.id))
            .map(result => {
                if (!result) {
                    throw new Error(`Cannot delete '${category.title}' because it contains '${dependantEntityName}'. Please delete them first and retry`);
                }
                return result;
            });
    }

    canDelete(taskType: TaskType): Observable<boolean> {
        return this.checkHasDependency(this.appFacade.objects.task.store, taskType, 'Tasks')
            .switchMap(() => super.canDelete(taskType));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/task-type/task-type.store-facade.ts